module.exports = __webpack_public_path__ + "img/_012.9e404025.png";